/**
 * Shared moderation menu items for call tiles and chat authors.
 * Parent owns open/close; these only fire the actions.
 */
export function ModerationActions({
  userId,
  userName,
  chatMuted,
  onMuteCall,
  onUnmuteCall,
  onMuteChat,
  onUnmuteChat,
  onKick,
  onBan,
  onDone,
}: {
  userId: string;
  userName: string;
  chatMuted: boolean;
  onMuteCall: (userId: string) => void;
  onUnmuteCall: (userId: string) => void;
  onMuteChat: (userId: string, minutes: number | null) => void;
  onUnmuteChat: (userId: string) => void;
  onKick: (userId: string) => void;
  onBan: (userId: string) => void;
  onDone: () => void;
}) {
  return (
    <>
      <button
        type="button"
        role="menuitem"
        onClick={() => {
          onMuteCall(userId);
          onDone();
        }}
      >
        Заглушить в звонке
      </button>
      <button
        type="button"
        role="menuitem"
        onClick={() => {
          onUnmuteCall(userId);
          onDone();
        }}
      >
        Вернуть голос
      </button>
      <hr />
      {!chatMuted ? (
        <>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              onMuteChat(userId, 5);
              onDone();
            }}
          >
            Мут чата · 5 мин
          </button>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              onMuteChat(userId, 30);
              onDone();
            }}
          >
            Мут чата · 30 мин
          </button>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              onMuteChat(userId, null);
              onDone();
            }}
          >
            Мут чата · до снятия
          </button>
        </>
      ) : (
        <button
          type="button"
          role="menuitem"
          onClick={() => {
            onUnmuteChat(userId);
            onDone();
          }}
        >
          Разрешить чат
        </button>
      )}
      <hr />
      <button
        type="button"
        role="menuitem"
        className="is-danger"
        onClick={() => {
          if (window.confirm(`Исключить ${userName} из звонка?`)) {
            onKick(userId);
          }
          onDone();
        }}
      >
        Кикнуть из звонка
      </button>
      <button
        type="button"
        role="menuitem"
        className="is-danger"
        onClick={() => {
          if (
            window.confirm(
              `Забанить ${userName}? Запрет писать в чат и исключение из звонка.`,
            )
          ) {
            onBan(userId);
          }
          onDone();
        }}
      >
        Забанить
      </button>
    </>
  );
}
